module.exports = __webpack_public_path__ + "static/img/xge.e5ecd49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xge.png
// module id = dSzg
// module chunks = 0